import { InteractionStatus } from '@azure/msal-browser'
import { useIsAuthenticated, useMsal } from '@azure/msal-react'
import { Navigate, useLocation } from 'react-router-dom'
import LoadingSpinner from '@/shared/components/ui/LoadingSpinner'
import type { ReactNode } from 'react'

interface Props {
  children: ReactNode
}

/**
 * Redirects unauthenticated users to /login.
 * Shows a spinner while MSAL is initialising (handles page-load redirect flow).
 */
export default function ProtectedRoute({ children }: Props) {
  const { inProgress } = useMsal()
  const isAuthenticated = useIsAuthenticated()
  const location = useLocation()

  // MSAL is still initialising or handling a redirect — wait before deciding
  if (inProgress !== InteractionStatus.None) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <LoadingSpinner size="lg" />
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return <>{children}</>
}
